<script>

let constant = {
  modal: {
    util: 'util',
    detail: 'detail',
    login: 'login',
    photoConfirm: 'photoConfirm'
  },
  upload: {
    maxFile: 5,
    maxSize: 1024
  }
}

export default constant
</script>



// WEBPACK FOOTER //
// src/utils/vue/Constant.vue